<template>
  <div id="applicationManagement">
    <div class="container" style="text-align: left">
      <div class="row" style="margin: 20px 0px">
        <label style="width: 100%; font-size: 24px">Student Application Management</label>
      </div>

      <div class="row common-row-div-margin" v-if="listCount > 0">
        <div class="enrolment-profile-container">
          <div style="text-align: center">
            <span style="font-weight: bold; display: block">{{ lang("Photo") }}</span>
            <small>(minimal size 300x300px)</small>

            <div style="margin: 20px 0px">
              <div class="enrolment-profile" style="position: relative">
                <div class="div-profile" style="height: 180px">
                  <img v-if="imageUrl" :src="imageUrl" alt="Avatar" class="stuImg"/>
                  <img v-else src="../assets/boy.png"/>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="enrolment-manage-container">
          <div class="enrol-manage-content-container">
            <div class="enrol-manage-child-container">
              <div style="display: flex; justify-content: space-between;">
                <label v-if="enrolStatus === 'Approved'">
                  <span style="padding: 5px 15px; border-radius: 6px; background: green; color: #ffffff;">
                    {{ enrolStatus }}
                  </span>
                </label>
                <label v-else>
                  <span style=" padding: 5px 15px; border-radius: 6px; background: red; color: #ffffff;">
                    {{ enrolStatus }}
                  </span>
                </label>
                <a :href="`${apiHost}/controller/Api.asmx/ExportApplicationAsPdf?id=${applicationFormID}`"
                   class="el-button el-button--secondary" target="_blank">PRINT (PDF)</a>
              </div>

              <section class="time-line-box">
                <div class="swiper-container text-center">
                  <div class="swiper-wrapper">
                    <div v-for="(item, index) in approverList" class="swiper-slide" :key="index" :title="item.comment">
                      <div class="timestamp">
                        <span class="date">{{ item.name }}</span>
                      </div>
                      <div
                        class="status"
                        :class="{ statusYetDone: item.status === 'Pending' }"
                      >
                        <span>{{ item.status }}</span>
                      </div>
                    </div>
                  </div>
                  <div class="swiper-pagination"></div>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Student Details
                </h5>

                <div>
                  <label>First Name</label>
                  <input class="form-control" type="text" v-model="form.APF_FirstName" :readonly="cantEdit"/>
                </div>
	              <div>
		              <label>Last Name</label>
		              <input class="form-control" type="text" v-model="form.APF_Surname" :readonly="cantEdit"/>
	              </div>
	              <div>
		              <label>Preferred Name</label>
		              <input class="form-control" type="text" v-model="form.APF_Preferred_Name" :readonly="cantEdit"/>
	              </div>
                <div>
                  <label>Date of Birth</label>
                  <input class="form-control" type="date" v-model="form.APF_DOB" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Commencement Date</label>
                  <input class="form-control" type="date" v-model="form.APF_CommencementDate" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Gender</label>
                  <select :disabled="cantEdit" class="form-control" v-model="form.APF_Gender">
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
                <div>
                  <label>Country of Birth</label>
                  <input class="form-control" type="text" v-model="form.APF_POB" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Nationality</label>
                  <input class="form-control" type="text" v-model="form.APF_Nationality" :readonly="cantEdit"/>
                </div>
                <div v-if="form.APF_DualCitizenship">
                  <label>Dual Citizenship</label>
                  <input class="form-control" type="text" v-model="form.APF_DualCitizenship" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Current School Name</label>
                  <input class="form-control" type="text" v-model="form.APF_CurrentSchool" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Current School Country</label>
                  <input class="form-control" type="text" v-model="form.APF_CurrentCountry" :readonly="cantEdit"/>
                </div>
                <div style="grid-column: 1/-1">
                  <label>Has your child been enrolled with EtonHouse previously?</label>
                  <select class="form-control" v-model="form.APF_EnrolPreviously" :disabled="cantEdit">
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div v-if="form.APF_EnrolPreviously === 'yes'">
                  <label>Child's Previously Enrolled School</label>
                  <select class="form-control" v-model="form.APF_EnrolPreviouslySchool" :disabled="cantEdit">
                    <option v-for="opt in schoolList" :value="opt.SchoolID" :key="opt.SchoolID">
                      {{ opt.SchoolName }}
                      <template v-if="opt.SchoolID === 'SCH201500000043' || opt.SchoolID === 'SCH201400000537'">(Pre-School)</template>
                    </option>
                  </select>
                </div>
                <div v-if="form.APF_EnrolPreviouslySchoolYear">
                  <label>Previously Enrolled Year</label>
                  <input type="text" :value="form.APF_EnrolPreviouslySchoolYear" class="form-control">
                </div>
                <div v-if="form.APF_PassportNumber">
                  <label>Passport No.</label>
                  <input type="text" :value="form.APF_PassportNumber" class="form-control">
                </div>
                <div v-if="form.APF_PassportExpiryDate">
                  <label>Passport Expiry Date</label>
                  <input type="date" :value="form.APF_PassportExpiryDate" class="form-control">
                </div>
                <div>
                  <label>Immigration Status</label>
                  <select class="form-control" v-model="form.APF_IDType" :disabled="cantEdit">
                    <option value="DP(Dependant Pass)">Dependent's Pass</option>
                    <option value="LTVP(Long Term Visit Pass)">
                      Long Term Visit Pass
                    </option>
                    <option value="PR(Permanent Resident)">
                      Permanent Resident
                    </option>
                    <option value="STPIP(Student Pass In Progress)">Student's Pass In Progress</option>
                    <option value="SC(Citizen)">Singapore Citizen</option>
                    <option value="STP(Student Pass)">Student's Pass</option>
                    <option value="Immigration Exemption Order">Immigration Exemption Order</option>
                  </select>
                </div>
                <div>
                  <label>Document No.</label>
                  <input class="form-control" type="text" v-model="form.APF_IDNumber" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Issue Date</label>
                  <input class="form-control" type="date" v-model="form.APF_IDPASSIssueDate" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Expiry Date</label>
                  <input class="form-control" type="date" v-model="form.APF_IDPASSExpiredDate" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>First(1st) Language</label>
                  <input class="form-control" type="text" v-model="form.APF_1stLang" :readonly="cantEdit"/>
                </div>
                <div v-if="form.APF_2ndLang">
                  <label>Second(2nd) Language (if applicable)</label>
                  <input class="form-control" type="text" v-model="form.APF_2ndLang" :readonly="cantEdit"/>
                </div>
                <div>
                  <label>Bilingual (English & Mandarin) Immersion Programme</label>
	                <select class="form-control" v-model="form.APF_BilingualProgram" :disabled="cantEdit">
		                <option value="Yes">Yes</option>
		                <option value="No">No</option>
	                </select>
                </div>
                <div v-if="form.APF_BilingualProgram === 'No'">
                  <label>Additional Language (Main Curriculum Only)</label>
                  <input class="form-control" type="text" v-model="form.APF_AdditionalLanguage" :readonly="cantEdit"/>
                </div>
                <div v-if="form.APF_Language">
                  <label>Language</label>
                  <input class="form-control" type="text" v-model="form.APF_Language" :readonly="cantEdit"/>
                </div>
                <div style="grid-column: 1/-1; display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 0.5rem;">
                  <div v-if="form.APF_EnglishReadingProficiency">
                    <label>English Proficiency - Reading</label>
                    <input class="form-control" type="text" v-model="form.APF_EnglishReadingProficiency" :readonly="cantEdit"/>
                  </div>
                  <div v-if="form.APF_EnglishWritingProficiency">
                    <label>English Proficiency - Writing</label>
                    <input class="form-control" type="text" v-model="form.APF_EnglishWritingProficiency" :readonly="cantEdit"/>
                  </div>
                  <div v-if="form.APF_EnglishSpeakingProficiency">
                    <label>English Proficiency - Speaking</label>
                    <input class="form-control" type="text" v-model="form.APF_EnglishSpeakingProficiency" :readonly="cantEdit"/>
                  </div>
                </div>
                <div style="grid-column: 1/-1">
                  <label>How did you hear about our school?</label>
                  <input class="form-control" type="text" v-model="form.APF_TrafficChannel" :readonly="cantEdit"/>
                </div>
	              <div style="grid-column: 1/-1">
		              <label>Primary contact for contracts, billing, school reports, email correspondence, etc.</label>
		              <input class="form-control" type="text" v-model="form.APFP_PrimaryParent" :readonly="cantEdit"/>
	              </div>
	              <div style="grid-column: 1/-1">
		              <label> Consent to EtonHouse to include student in publications, promotional photos/videos, IB materials,
			              and social media postings not limited to Facebook, Instagram, or Youtube within Singapore and internationally.</label>
		              <input class="form-control" type="text" v-model="form.APF_DeclarePublication" :readonly="cantEdit"/>
	              </div>

              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr;
                  grid-column-gap: 1rem;
                "
                v-if="form.siblings.length > 0"
              >
                <h5 style="margin: 10px 0 20px; padding: 2px 0; grid-column: 1/-1">
                  Siblings
                </h5>

                <div
                  v-for="sib in form.siblings"
                  :key="sib.APS_ID"
                  style="
                    display: grid;
                    grid-template-columns: repeat(5, auto);
                    grid-column-gap: 1rem;
                  "
                >
                  <div>
                    <label>Name</label>
                    <input class="form-control" type="text" v-model="sib.APS_Name" :readonly="true"/>
                  </div>
                  <div style="width: 100px">
                    <label>Gender</label>
                    <input class="form-control" type="text" v-model="sib.APS_Gender" :readonly="true"/>
                  </div>
                  <div style="width: 150px">
                    <label>Date of Birth</label>
                    <input class="form-control" type="date" v-model="sib.APS_DOB" :readonly="true"/>
                  </div>
	                <div v-if="sib.APS_PresentSchool">
		                <label>Present School</label>
		                <input class="form-control" type="text" v-model="sib.APS_PresentSchool" :readonly="true"/>
	                </div>
	                <div v-if="sib.APS_PresentSchool === 'other'">
		                <label>Other School</label>
		                <input class="form-control" type="text" v-model="sib.APS_OtherSchool" :readonly="true"/>
	                </div>
	                <div v-if="sib.APS_PresentSchool === 'notSchoolGoing'">
		                <label>Age</label>
		                <input class="form-control" type="text" v-model="sib.APS_Age" :readonly="true"/>
	                </div>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
                v-if="form.APFP_FatherFirstName"
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Father Details
                </h5>

                <div>
                  <label>First Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherFirstName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Last Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherLastName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Middle Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherMiddleName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Nationality</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherNationality" :readonly="cantEdit"/>
                </div>

                <div style="grid-column: 1/-1">
                  <label>Email</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherPersonalEmail" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (M)</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherMobile" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (H)</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherHomeTel" :readonly="cantEdit"/>
                </div>

                <div v-if="form.APFP_FatherResidencyStatus">
                  <label>Residency Status</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherResidencyStatus" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Passport / FIN / NRIC No.</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherResidencyDocNo" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Expiry Date</label>
                  <input class="form-control" type="date" v-model="form.APFP_FatherResidencyDocExpiry" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Issue Date</label>
                  <input class="form-control" type="date" v-model="form.APFP_FatherResidencyDocIssueDate" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Company Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherCompanyName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Occupation</label>
                  <input class="form-control" type="text" v-model="form.APFP_FatherOccupation" :readonly="cantEdit"/>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
                v-if="form.APFP_MotherFirstName"
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Mother Details
                </h5>

                <div>
                  <label>First Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherFirstName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Last Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherLastName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Middle Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherMiddleName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Nationality</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherNationality" :readonly="cantEdit"/>
                </div>

                <div style="grid-column: 1/-1">
                  <label>Email</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherPersonalEmail" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (M)</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherMobile" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (H)</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherHomeTel" :readonly="cantEdit"/>
                </div>

                <div v-if="form.APFP_MotherResidencyStatus">
                  <label>Residency Status</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherResidencyStatus" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Passport / FIN / NRIC No.</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherResidencyDocNo" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Expiry Date</label>
                  <input class="form-control" type="date" v-model="form.APFP_MotherResidencyDocExpiry" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Issue Date</label>
                  <input class="form-control" type="date" v-model="form.APFP_MotherResidencyDocIssueDate" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Company Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_MotherCompanyName" :readonly="cantEdit"/>
                </div>

	              <div>
		              <label>Occupation</label>
		              <input class="form-control" type="text" v-model="form.APFP_MotherOccupation" :readonly="cantEdit"/>
	              </div>

	              <div>
		              <label>Household Income</label>
		              <input class="form-control" type="text" v-model="form.APFP_AnnualHouseHoldIncome" :readonly="cantEdit"/>
	              </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
                v-if="form.APFP_LegalGuardianName"
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Local Guardian Details
                </h5>

                <div>
                  <label>Name</label>
                  <input class="form-control" type="text" v-model="form.APFP_LegalGuardianName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Email</label>
                  <input class="form-control" type="text" v-model="form.APFP_LegalGuardianEmail" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (M)</label>
                  <input class="form-control" type="text" v-model="form.APFP_LegalGuardianMobile" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (H)</label>
                  <input class="form-control" type="text" v-model="form.APFP_LegalGuardianHomeTel" :readonly="cantEdit"/>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 2fr 1fr 1fr 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Emergency Contact
                </h5>

                <div>
                  <label>Person 1</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer1Name" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Relationship</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer1Relation" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (M)</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer1Mobile" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (H)</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer1Tel" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Person 2</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer2Name" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Relationship</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer2Relation" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (M)</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer2Mobile" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel (H)</label>
                  <input class="form-control" type="text" v-model="form.APF_Emer2Tel" :readonly="cantEdit"/>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Correspondence
                </h5>

                <div>
                  <label>Primary contact for all</label>
                  <input class="form-control" type="text" v-model="form.APF_CorrPrimaryContact" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Student will be residing with</label>
                  <input class="form-control" type="text" v-model="form.APF_CorrResidingWith" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Address</label>
                  <textarea class="form-control" v-model="form.APF_CorrAddress" :readonly="cantEdit"></textarea>
                </div>

                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem;">
                  <div>
                    <label>Postal</label>
                    <input class="form-control" type="text" v-model="form.APF_CorrPostal" :readonly="cantEdit"/>
                  </div>
                  <div>
                    <label>Country</label>
                    <input class="form-control" type="text" v-model="form.APF_CorrCountry" :readonly="cantEdit"/>
                  </div>
                </div>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Billing Name &amp; Address for Tuition Fees (if different from above)
                </h5>

                <div style="grid-column: 1/-1">
                  <label>Billing Name</label>
                  <input class="form-control" type="text" v-model="form.APF_BillingName" :readonly="cantEdit"/>
                </div>

                <div style="grid-column: 1/-1">
                  <label>Address</label>
                  <textarea class="form-control" v-model="form.APF_BillingAddress" :readonly="cantEdit"></textarea>
                </div>

                <div>
                  <label>Postal</label>
                  <input class="form-control" type="text" v-model="form.APF_BillingPostal" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Country</label>
                  <input class="form-control" type="text" v-model="form.APF_BillingCountry" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Email</label>
                  <input class="form-control" type="text" v-model="form.APF_BillingEmail" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel</label>
                  <input class="form-control" type="text" v-model="form.APF_BillingTel" :readonly="cantEdit"/>
                </div>
              </section>

              <!--Supportive Information-->
              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  Supportive Information
                </h5>

                <div v-for="ans in form.answers.filter(a => a.APFA_Answer)" :key="`ANS1_${ans.ID}`">
                  <div v-if="ans.APFQ_Ordering <= 25">
                    <label v-text="ans.APFQ_Desc"></label>
                    <textarea class="form-control" type="text" v-model="ans.APFA_Answer" :readonly="true" rows="3"/>
                    <textarea class="form-control" v-if="ans.APFA_Answer === 'yes' && ans.APFA_AnswerValue" rows="3" v-text="ans.APFA_AnswerValue" :readonly="true"></textarea>
                  </div>
                </div>

                <template v-if="!isPreschool">
	                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
		                Additional Information
	                </h5>

	                <div v-for="ans in form.answers.filter(a => a.APFA_Answer)" :key="`ANS2_${ans.ID}`">
		                <div v-if="ans.APFQ_Ordering > 25">
			                <label v-text="ans.APFQ_Desc"></label>
			                <input class="form-control" type="text" v-model="ans.APFA_Answer" :readonly="true"/>
		                </div>
	                </div>
                </template>
              </section>

              <section
                style="
                  margin-bottom: 10px;
                  display: grid;
                  grid-template-columns: 1fr 1fr;
                  grid-column-gap: 1rem;
                "
              >
                <h5 class="py-1" style="margin: 10px 0 20px; grid-column: 1/-1">
                  For Authorised Representative
                </h5>

                <div>
                  <label>Name</label>
                  <input class="form-control" type="text" v-model="form.APF_ReferralAgentName" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Email</label>
                  <input class="form-control" type="text" v-model="form.APF_ReferralAgentEmail" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Company Name</label>
                  <input class="form-control" type="text" v-model="form.APF_ReferralCompany" :readonly="cantEdit"/>
                </div>

                <div>
                  <label>Tel</label>
                  <input class="form-control" type="text" v-model="form.APF_ReferralAgentTel" :readonly="cantEdit"/>
                </div>
              </section>
            </div>

            <div class="enrol-manage-attachment-container" style="margin-top: 30px">
              <h5 class="py-1">Attachment(s)</h5>

              <div class="row common-row-div-margin" style="border: 1px solid black; border-radius: 5px">
                <ul style="padding: 20px;">
                  <li v-for="items in attachmentList.filter(items => items.APAT_UploadType !== 'Declare & Agreement')" class="media-file-image-container" :key="items.ID">
                    <a :href="items.APAT_FilePath + items.APAT_EnrolFileName + items.APAT_EnrolFileExt" target="_blank">
                      {{ items.APAT_EnrolFileName }}
                    </a>
                  </li>
                </ul>
              </div>
              <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 1rem; row-gap: 0.5rem; margin-top: 0.5rem; place-items: center;">
                <span style="white-space: nowrap;">Add Attachment:</span>
                <div style="display: flex; width: 100%;">
                  <input class="form-control mb-0" type="file" id="new-attachment-input">
                  <el-button type="secondary" @click="onClickAddNewAttachments($event)">Upload</el-button>
                </div>
                <span style="white-space: nowrap;">Attachment Type:</span>
                <input class="form-control mb-0" type="text" v-model="fileUploadType"/>
              </div>
            </div>

            <div class="enrol-manage-attachment-container" style="margin-top: 30px">
              <h5 class="py-1">Request Applicant To Make Changes</h5>
              <label>Comment</label>
              <textarea class="form-control mb-2" type="text" name="comment" v-model="requestEditComment"/>
              <el-button class="" type="secondary" v-on:click="requestApplicantEdits()">Send Email</el-button>
            </div>

            <div class="enrol-manage-attachment-container"
                 style="margin-top: 30px; display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 1rem;">
              <div style="grid-column: 1/-1;"><h5 class="py-1">Kagami</h5></div>
              <div>
                <label>Parent Liaison</label>
                <select class="form-control" v-model="form.APF_ParentLiaison" :disabled="cantEdit">
                  <option v-for="(opt, id) in parentLiaisonList" :value="opt.CONid" :key="`PL_${id}`">
                    {{ opt.CONname }}
                  </option>
                </select>
              </div>
              <div>
                <label>Family No</label>
                <input type="text" class="form-control" v-model="form.APF_FamilyNumber" :disabled="cantEdit">
              </div>
              <div>
                <label>Student No</label>
                <input type="text" class="form-control" v-model="StudentIndexNumber" :disabled="true">
              </div>
              <div>
                <label>Academic Year</label>
                <input type="text" class="form-control" v-model="academicYear.academicYear" :disabled="true">
              </div>
              <div>
                <label>Academic Level</label>
                <input type="text" class="form-control" v-model="academicYear.level" :disabled="true">
              </div>
            </div>

            <div class="enrol-manage-attachment-container" style="margin-top: 30px">
              <h5 class="py-1">Comments</h5>
              <div>
                <label>General Comment</label>
                <textarea class="form-control" type="text" v-model="form.APF_Comment1"/>
              </div>
              <div>
                <label>PLO Comment</label>
                <textarea class="form-control" type="text" v-model="form.APF_Comment2"/>
              </div>
              <div>
                <label>Post Review Comment</label>
                <textarea class="form-control" type="text" v-model="form.APF_Comment3"/>
              </div>
            </div>

          </div>
          <div class="enrol-manage-button-container" style="margin: 20px 0">
            <div v-if="listCount >= 0" style="display: flex;">
              <el-button-group>
                <el-button type="primary" v-on:click="approveClick('Approve')"
                           :disabled="!enableApproveRejectButton">Approve
                </el-button>
                <el-button type="danger" :disabled="!enableApproveRejectButton"
                           v-if="currentAPMD_Lvl > 1" v-on:click="rejectClick('Reject')">Reject
                </el-button>
                <el-button type="warning" v-on:click="deleteClick()"
                           :disabled="!['Draft', 'Pending'].includes(enrolStatus)">Delete
                </el-button>
              </el-button-group>
              <el-button class="ml-auto" type="secondary" v-on:click="saveForm()">Save</el-button>
            </div>
          </div>
          <hr>
          <div style="display: flex; flex-wrap: wrap; gap: 0.5rem;">
            <a :href="`/student?id=${this.form.APF_FK_Student_ID}`" target="_blank" v-if="this.form.APF_FK_Student_ID">
              <el-button type="secondary">View Student</el-button>
            </a>
            <el-button type="secondary" v-on:click="createStudent()">{{ this.form.APF_FK_Student_ID ? 'Update' : 'Create' }} Student</el-button>
            <el-button class="ml-0" type="secondary" v-on:click="deleteStudent()" v-if="this.form.APF_FK_Student_ID">Delete Student</el-button>
          </div>
        </div>
      </div>

      <div class="emptylist-info" v-else>
        <div class="emptylist__img">
          <img src="../assets/table-loading.png"/>
        </div>
      </div>
    </div>

    <b-modal class=".modal-sm" id="rejectModal" title="Reject" ok-only ok-variant="secondary" ok-title="Cancel" ref="showRejectModal" hide-footer>
      <div class=".modal-sm">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Please provide the rejection reason here.</label>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-6">
          <el-input v-model="inputRejectReason" type="textarea" placeholder=" "></el-input>
        </div>
        <div class="row custom-modal-footer">
          <div class="col-lg-6">
            <button @click="hideModal()" class="btn btn-secondary float-left">
              Cancel
            </button>
          </div>
          <div class="col-lg-6">
            <button v-on:click="rejectClick()" class="btn btn-primary float-right">
              Confirmed?
            </button>
          </div>
        </div>
        <br/>
      </div>
    </b-modal>

    <b-modal class=".modal-sm" id="approveModal" title="Approve" ok-only ok-variant="secondary" ok-title="Cancel" ref="showApproveModal" hide-footer>
      <div class=".modal-sm">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <label>Confirmed?</label>
        </div>
        <div class="row custom-modal-footer">
          <div class="col-lg-6">
            <button @click="hideModal()" class="btn btn-secondary float-left">
              Cancel
            </button>
          </div>
          <div class="col-lg-6">
            <button v-on:click="confirmApproveClick()" class="btn btn-primary float-right">
              OK?
            </button>
          </div>
        </div>
        <br/>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import DataSource from "../data/datasource";
import {lang} from "../locale/index";
import { isPreschoolApplication } from "@/pages/application/const/applicationConst";
import { getSchoolSession } from "@/helper/util_custom";

export default {
  name: "applicationManagement",
  data() {
    return {
      authUserEmail: Cookies.get('userEmailSession'),
      apiHost: process.env.VUE_APP_ROOT_API,
      form: {
        APF_FK_Student_ID: null,
	      APF_Surname: null,
	      APF_Preferred_Name: null,
        APF_FirstName: null,
        APF_DOB: null,
        APF_POB: null,
        APF_IDType: null,
        APF_IDNumber: null,
        APF_PassportNumber: null,
        APF_PassportExpiryDate: null,
        APF_Gender: null,
        APF_HomeAddress: null,
        APF_Nationality: null,
        APF_CurrentSchool: null,
        APF_CurrentCountry: null,
        APF_EnrolPreviously: null,
        APF_EnrolPreviouslySchool: null,
        APF_IDPASSExpiredDate: null,
        APF_1stLang: null,
        APF_2ndLang: null,
        APF_Emer1Name: null,
        APF_Emer1Relation: null,
        APF_Emer1Tel: null,
        APF_Emer1Mobile: null,
        APF_Emer2Name: null,
        APF_Emer2Relation: null,
        APF_Emer2Tel: null,
        APF_Emer2Mobile: null,
        APF_CorrResidingWith: null,
        APF_CorrAddress: null,
        APF_CorrPostal: null,
        APF_CorrCountry: null,
        APF_BillingName: null,
        APF_BillingAddress: null,
        APF_BillingPostal: null,
        APF_BillingCountry: null,
        APF_BillingEmail: null,
        APF_BillingTel: null,
        APF_Comment1: null,
        APF_Comment2: null,
        APF_Comment3: null,
        APF_ReferralAgentName: null,
        APF_ReferralAgentMobile: null,
        APF_ReferralAgentEmail: null,
        APF_ReferralAgentTel: null,
        APF_ReferralCompany: null,
        // parents / guardians
        APFP_FatherFirstName: null,
        APFP_FatherLastName: null,
        APFP_FatherNationality: null,
        APFP_FatherResidencyDocNo: null,
        APFP_FatherOccupation: null,
        APFP_FatherCompanyName: null,
        APFP_FatherMobile: null,
        APFP_FatherHomeTel: null,
        APFP_FatherPersonalEmail: null,
        APFP_FatherMiddleName: null,
        APFP_FatherResidencyDocExpiry: null,
        APFP_MotherFirstName: null,
        APFP_MotherLastName: null,
        APFP_MotherNationality: null,
        APFP_MotherResidencyDocNo: null,
        APFP_MotherOccupation: null,
        APFP_MotherCompanyName: null,
        APFP_MotherMobile: null,
        APFP_MotherHomeTel: null,
        APFP_MotherPersonalEmail: null,
        APFP_MotherMiddleName: null,
        APFP_MotherResidencyDocExpiry: null,
        APFP_LegalGuardianName: null,
        APFP_LegalGuardianEmail: null,
        APFP_LegalGuardianMobile: null,
        APFP_LegalGuardianHomeTel: null,
        APFP_PrimaryParent: null,
        APF_CorrPrimaryContact: null,
        // questions and answers
        answers: [],
        siblings: [],
      },
      approverList: [],
      approverRemark: "",
      attachmentList: [],
      inputRejectReason: "",
      applicationFormID: "",
      enrolBindingList: [],
      datePicker: {
        disabledDate(date) {
          return date < new Date().getTime() - 24 * 60 * 60 * 1000;
        }
      },
      enrolStatus: "",
      disabled: true,
      imageUrl: "",
      listCount: "",
      enrolFilter: [],
      triggerParentEmailRemark: "",
      primaryEmailAddress: "",
      currentAPFID: "",
      schoolList: [],
      requestEditComment: '',
      parentLiaisonList: [],
      academicYear: {},
      fileUploadType: "Supporting Information",
      StudentIndexNumber: "",
	    isPreschool: false,
    };
  },
  async mounted() {
    window.V = this;
    if (this.$route.query.id) {
      const apfId = this.$route.query.id;
			this.isPreschool = isPreschoolApplication(getSchoolSession())
      await this.getApplicationDetail(apfId);
      await this.getApproversDetail(apfId);
    }
    this.schoolList = (await DataSource.shared.getSchoolDropdownList("UTY201300000061"))?.Table;
    this.parentLiaisonList = (await DataSource.shared.getUsers({CONSchool: this.form.APF_ApplicationSchool, CONType: "Parent Liaison"}));
    this.academicYear = (await DataSource.shared.getAutoAssignLevelAcademicYear(this.form.APF_CommencementDate, this.form.APF_DOB, this.form.APF_ApplicationSchool))?.Table?.[0] ?? null;
  },
  methods: {
    lang,

    async getApplicationDetail(apfId) {
      try {
        const resp = await DataSource.shared.getApplicationFormDetail(apfId);
        this.listCount = resp.FormTable.length;
        if (resp) {
          if (resp.code === "99") {
          } else {
            resp.AttachTable.forEach(n => {
              if (n.APAT_UploadType === "stuIMG") {
                this.imageUrl = n.APAT_FilePath + n.APAT_EnrolFileName + n.APAT_EnrolFileExt;
              }
            });

            if (resp.AttachTable) {
              this.attachmentList = resp.AttachTable;
            }
            if (resp.AnswerTable) {
              this.form.answers = resp.AnswerTable;
            }
            if (resp.SiblingTable) {
              this.form.siblings = resp.SiblingTable;
              this.form.siblings.forEach(s => (s.APS_DOB = s.APS_DOB.slice(0, 10)));
            }
            this.enrolBindingList = resp.FormTable;
            this.enrolBindingList.forEach(m => {
              this.applicationFormID = m.APF_ID;
              this.currentAPFID = m.FK_APF_ID;
              this.enrolStatus = m.APF_Status;
              for (let k in m) {
                const isDateAttribute =
                    k === "APF_DOB" ||
                    k === "APF_PassportExpiryDate" ||
                    k === "APF_CommencementDate" ||
                    k === "APF_IDPASSExpiredDate" ||
                    k === "APF_IDPASSIssueDate" ||
                    k === "APFP_FatherResidencyDocExpiry" ||
                    k === "APFP_FatherResidencyDocIssueDate" ||
                    k === "APFP_MotherResidencyDocExpiry" ||
                    k === "APFP_MotherResidencyDocIssueDate";
                if (isDateAttribute) {
                  this.form[k] = m[k].slice(0, 10);
                } else {
                  this.form[k] = m[k];
                }
              }
            });
						switch (this.form?.APF_BillingName){
							case "faCompany":
								this.form.APF_BillingName = this.form?.APFP_FatherCompanyName;
								break;
							case "maCompany":
								this.form.APF_BillingName = this.form?.APFP_MotherCompanyName;
								break;
							case "father":
								this.form.APF_BillingName = this.form?.APFP_FatherFirstName;
								break;
							case "mother":
								this.form.APF_BillingName = this.form?.APFP_MotherFirstName;
								break;
						}
            this.StudentIndexNumber = resp.Others.StudentNumber;
            this.form.APF_FamilyNumber = resp.FormTable.APF_FamilyNumber || resp.Others.FamilyNumber;
          }
        }
      } catch (e) {
        this.results = e;
      }
    },

    handleSelectionChange() {
    },

    async routeToStudentPage() {
      this.$router.push("student?eid=" + this.applicationFormID);
    },

    isImage(APAT_EnrolFileExt) {
      let ext = String(APAT_EnrolFileExt).toUpperCase();
      let isImage = false;

      switch (ext) {
        case ".PNG":
        case ".JPG":
        case ".BMP":
        case ".GIF":
        case ".JPEG":
          isImage = true;
          break;
        default:
          isImage = false;
          break;
      }

      return isImage;
    },

    getSource(file) {
      if (file.APAT_EnrolFileName === "ParentSignature") {
        return file.APAT_OriginalFileString;
      } else {
        if (this.isImage(file.APAT_EnrolFileExt)) {
          return "data:" + file.APAT_FileType + ";base64," + file.APAT_OriginalFileString;
        } else if (file.APAT_EnrolFileExt.toLowerCase() === ".pdf") {
          return "data:" + file.APAT_FileType + ";base64," + file.APAT_OriginalFileString;
        } else {
          return "";
        }
      }
    },

    approveClick(mode) {
      this.$prompt("Please input remark (Optional)\r\n" + "", mode.toString(), {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel"
      })
        .then(({value}) => {
          this.approverRemark = value;
          this.$vs.loading();
          this.approveRejectApplicationForm(mode, value).then(val => {
            if (val) {
              if (val.code === "99") {
                this.$notify.error({
                  title: "Error 99", message: "Error 99!", type: "Error 99"
                });
              } else if (val.code === "2") {
              } else if (val.code === "3") {
                this.$notify.error({
                  title: "Approve Failed", message: "Status not valid!", type: "approve"
                });
              } else if (val.code === "1") {
                //todo Approved. refresh the page
                this.$notify.success({
                  title: "Success", message: "Approved!", type: "success", duration: 2000
                });
                setTimeout(() => this.$router.push("applicationList"), 3000);
              }
            }
            this.getApproversDetail();
            this.$vs.loading.close();
          });
        })
        .catch((err) => {
          console.error(err)
          this.$message({
            type: "info",
            message: "Canceled"
          });
        });
    },

    rejectClick(mode) {
      this.$prompt("Please input remark(Mandatory)", mode.toString(), {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel"
      }).then(({value}) => {
        if (!value) {
          this.$notify.error({
            title: "Mandatory Field",
            message: "Please input remark",
            type: "Error"
          });
        } else {
          this.$vs.loading();
          this.approveRejectApplicationForm(mode, value)
            .then(val => {
              if (val) {
                if (val.code === "99") {
                } else if (val.code === "2") {
                } else if (val.code === "3") {
                  this.$notify.error({
                    title: "Reject Failed",
                    message: "Status not valid!",
                    type: "reject"
                  });
                } else if (val.code === "1") {
                  //todo Rejected. refresh the page
                  this.$notify({
                    title: "Rejected",
                    message: "Rejected!",
                    type: "reject"
                  });
                  this.getApplicationDetail(this.currentAPFID);
                }
              }
              this.getApproversDetail();
              this.$vs.loading.close();
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "Canceled"
              });
            });
        }
      });
    },

    deleteClick() {
      this.$confirm("Confirm archiving this application?", 'Archive', {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: 'warning'
      }).then(() => {
        this.$vs.loading();
        this.approveRejectApplicationForm('Delete', '')
          .then(() => {
            this.$notify({
              title: "Archived",
              message: "Application Archived!",
              type: "reject"
            });
            this.getApplicationDetail(this.currentAPFID);
            this.$vs.loading.close();
            this.$router.push('ApplicationList');
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Error!"
            });
          });
      });
    },

    async getApproversDetail(apfId = null) {
      this.approverList = await DataSource.shared.callWebService(`/controller/Api.asmx/GetApproversOverview`, {APF_ID: apfId || this.currentAPFID}, 'POST');
    },

    async approveRejectApplicationForm(mode, reason) {
      return await DataSource.shared.approveOrRejectApplicationForm(
        this.currentAPMD_ID,
        this.currentAPFID,
        mode,
        reason,
        {APF_Comment1: this.form.APF_Comment1, APF_Comment2: this.form.APF_Comment2, APF_Comment3: this.form.APF_Comment3}
      );
    },

    async onClickAddNewAttachments() {
      const inputFiles = document.querySelector("#new-attachment-input")?.files;
      const files = [];
      for await (let file of inputFiles) {
        if ((file.size / 1024 / 1024) > 10) {
          this.$notify.error({title: "Error", message: "File limit exceeded 10MB"});
          continue;
        }
        files.push(file);
      }
      if (files.length > 0) {
        await this.saveNewAttachments(files, this.fileUploadType);
        location.reload(true)
      } else {
        this.$notify.error({title: "Error", message: "No Files Selected"});
      }
    },

    async saveNewAttachments(files, type) {
      const formData = new FormData();
      formData.append(`APF_ID`, this.currentAPFID);
      formData.append(`UserID_Session`, Cookies.get('userIDSession'));
      formData.append(`APAT_UploadType`, type)
      for (let i = 0; i < files.length; i++) {
        formData.append(`files_${i}`, files[i]);
      }
      const request = {
        url: `${process.env.VUE_APP_ROOT_API}/controller/Api.asmx/SaveApplicationAttachment`,
        type: 'POST',
        data: formData,
        enctype: 'multipart/form-data',
        cache: false, processData: false, contentType: false, async: false, json: false,
        success: function (response) {
          return response;
        }
      };
      await jQuery.ajax(request);
    },

    async saveForm() {
      this.$vs.loading();
      await DataSource.shared.callWebService("/controller/Api.asmx/UpdateApplicationForm", this.form, "POST");
      window.location.reload();
    },

    async createStudent() {
      this.$vs.loading();
      await DataSource.shared.CreateStudentFromApplicationForm(this.currentAPFID);
      window.location.reload();
    },

    async deleteStudent() {
      if (confirm('Are you sure you want to delete the student profile?')) {
        this.$vs.loading();
        await DataSource.shared.DeleteStudentFromApplicationForm(this.form.APF_FK_Student_ID);
        window.location.reload();
      }
    },

    async requestApplicantEdits() {
      const payload = {
        APF_ID: this.form.APF_ID,
        comment: this.requestEditComment,
      };
      this.$vs.loading();
      await DataSource.shared.callWebService("/controller/Api.asmx/RequestApplicantToUpdateApplicationForm", payload, "POST");
      this.$notify.success({title: "Success", message: "Email Scheduled", type: "success", duration: 3000});
      this.$vs.loading.close();
    },
  },
  computed: {
    cantEdit: function () {
      return 'darren.li@etonhouse.com.sg' !== this.authUserEmail && this.currentAPMD_Lvl > 1;
    },
    enableApproveRejectButton: function () {
      return this.approverEmails.includes(this.authUserEmail) && this.enrolStatus === "Pending";
    },
    approverEmails: function () {
      return ['darren.li@etonhouse.com.sg', ...this.approverList.map(x => x.email).flat()];
    },
    currentAPMD_ID: function () {
      return this.approverList.find(x => x.status === 'Pending')?.apmdId;
    },
    currentAPMD_Lvl: function () {
      return Number(this.approverList.find(x => x.status === 'Pending')?.level ?? 0);
    },
  }
};
</script>

<style scoped>
h5 {
  text-align: center;
  background-color: rgb(43, 0, 128);
  border-radius: 5px;
  color: white;
  margin: 0px 10px 10px 0px;
}

.time-line-box {
  padding: 30px 0;
  width: 100%;
}

.time-line-box .timestamp {
  margin: auto auto 5px;
  padding: 0 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.time-line-box .status {
  padding: 0px 10px;
  display: flex;
  justify-content: center;
  border-top: 3px solid #426dff;
  position: relative;
  transition: all 200ms ease-in;
}

.time-line-box .statusYetDone {
  border-top: 2px solid #d8dfe6;
}

.time-line-box .status span {
  padding-top: 8px;
}

.time-line-box .status span:before {
  content: "";
  width: 10px;
  height: 10px;
  background-color: #ff4242;
  border-radius: 12px;
  border: 2px solid #426dff;
  position: absolute;
  left: 50%;
  top: 0%;
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}

.time-line-box .statusYetDone span:before {
  content: "";
  width: 12px;
  height: 12px;
  background-color: #d3d9e8;
  border-radius: 12px;
  border: 2px solid #d3d9e8;
  position: absolute;
  left: 50%;
  top: 0;
  transform: translate(-50%, -50%);
  transition: all 200ms ease-in;
}

.swiper-container {
  width: 95%;
  margin: auto;
  overflow-y: auto;
}

.swiper-wrapper {
  display: inline-flex;
  flex-direction: row;
  overflow-y: auto;
  justify-content: center;
}

.swiper-container::-webkit-scrollbar-track {
  background: #f3f1f1;
}

.swiper-container::-webkit-scrollbar {
  height: 8px;
}

.swiper-container::-webkit-scrollbar-thumb {
  background: #7442ff !important;
}

.swiper-slide {
  text-align: center;
  font-size: 12px;
  width: 200px;
  height: 100%;
  position: relative;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul li {
  margin: 0;
  padding: 0;
}

h5 {
  font-size: 1.1rem;
}

.stuImg {
}

.media-file-image-container {
  min-height: inherit;
  border-radius: inherit;
  margin: 0px 20px 20px 0px;
  max-height: 150px;
  text-align: center;
  display: inline-block;
}

.div-profile img {
  height: 180px;
  width: 180px;
  border-radius: 50%;
  object-fit: scale-down;
}

.enrolment-profile-container {
  background: #ffffff;
  border-radius: 6px;
  height: 300px;
  width: 25%;
  padding: 20px;
}

.enrolment-manage-container {
  background: #ffffff;
  border-radius: 6px;
  min-height: 100vh;
  width: 73%;
  margin-left: auto;
  padding: 20px;
}

.common-row-div-margin {
  margin: 0;
}
</style>
